import React from 'react';

const Sidebar = ({ isOpen, onToggle }) => {
  if (!isOpen) {
    return (
      <div className="w-12 border-r flex flex-col items-center py-4" style={{ backgroundColor: 'var(--bg-primary)', borderColor: 'var(--text-secondary)' }}>
        <button 
          onClick={onToggle}
          className="cursor-pointer p-[7px] flex rounded-xl hover:bg-gray-100 dark:hover:bg-gray-900 transition"
          style={{ color: 'var(--text-secondary)' }}
        >
          <div className="m-auto self-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="2"
              stroke="currentColor"
              className="size-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
              />
            </svg>
          </div>
        </button>
      </div>
    );
  }

  return (
    <div className="w-64 border-r flex flex-col" style={{ backgroundColor: 'var(--bg-primary)', borderColor: 'var(--text-secondary)' }}>
      {/* Sidebar Header */}
      <div className="p-4 border-b" style={{ borderColor: 'var(--text-secondary)' }}>
        {/* Top Section - Menu Toggle and New Chat */}
        <div className="px-1.5 flex justify-between space-x-1 text-gray-600 dark:text-gray-400 mb-4">
          <button
            className="cursor-pointer p-[7px] flex rounded-xl hover:bg-gray-100 dark:hover:bg-gray-900 transition"
            onClick={onToggle}
          >
            <div className="m-auto self-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="size-5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25H12"
                />
              </svg>
            </div>
          </button>
        </div>
        
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 via-purple-500 to-purple-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-sm">LC</span>
          </div>
          <button className="flex items-center space-x-2 hover:bg-gray-800 px-3 py-1 rounded" style={{ color: 'var(--text-primary)' }}>
            <span>New Chat</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
          </button>
        </div>
      </div>

      {/* Navigation Sections */}
      <div className="flex-1 overflow-y-auto">
        {/* Notes Section */}
        <div className="p-2">
          <div className="flex items-center space-x-2 px-3 py-2 hover:bg-gray-800 rounded cursor-pointer" style={{ color: 'var(--text-secondary)' }}>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span>Notes</span>
          </div>
        </div>

        {/* Workspace Section */}
        <div className="p-2">
          <div className="flex items-center space-x-2 px-3 py-2 hover:bg-gray-800 rounded cursor-pointer" style={{ color: 'var(--text-secondary)' }}>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <span>Workspace</span>
          </div>
        </div>

        {/* Search Section */}
        <div className="p-2">
          <div className="flex items-center space-x-2 px-3 py-2 hover:bg-gray-800 rounded cursor-pointer" style={{ color: 'var(--text-secondary)' }}>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <span>Search</span>
          </div>
        </div>

        {/* Chats Section */}
        <div className="p-2">
          <div className="px-3 py-2 text-sm font-medium" style={{ color: 'var(--text-secondary)' }}>Chats</div>
          <div className="space-y-1">
            <div className="px-3 py-2 hover:bg-gray-800 rounded cursor-pointer text-sm" style={{ color: 'var(--text-secondary)' }}>Today</div>
            <div className="px-6 py-1 hover:bg-gray-800 rounded cursor-pointer text-sm" style={{ color: 'var(--text-secondary)' }}>
              <div className="w-4 h-4 bg-yellow-500 rounded-full inline-block mr-2"></div>
              Greeting Exchange
            </div>
            
            <div className="px-3 py-2 hover:bg-gray-800 rounded cursor-pointer text-sm" style={{ color: 'var(--text-secondary)' }}>Previous 30 days</div>
            <div className="px-6 py-1 hover:bg-gray-800 rounded cursor-pointer text-sm" style={{ color: 'var(--text-secondary)' }}>AI Language Model: Claude Code</div>
            <div className="px-6 py-1 hover:bg-gray-800 rounded cursor-pointer text-sm" style={{ color: 'var(--text-secondary)' }}>🌊 Peaceful Ocean View</div>
            <div className="px-6 py-1 hover:bg-gray-800 rounded cursor-pointer text-sm" style={{ color: 'var(--text-secondary)' }}>🔧 AI Server Setup</div>
            <div className="px-6 py-1 hover:bg-gray-800 rounded cursor-pointer text-sm" style={{ color: 'var(--text-secondary)' }}>New Chat</div>
          </div>
        </div>
      </div>

      {/* User Profile */}
      <div className="p-4 border-t" style={{ borderColor: 'var(--text-secondary)' }}>
        <div className="flex items-center space-x-2">
          <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--bg-secondary)', color: 'var(--text-primary)' }}>
            <span className="text-sm">U</span>
          </div>
          <span style={{ color: 'var(--text-secondary)' }}>User</span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;